import { Component, type ErrorInfo } from 'react';
import { captureException } from 'r/utils';
import { UiError } from 'r/ui';
import App from './App';

export default class Root extends Component {
  state = {
    globalUiError: false,
  };

  componentDidCatch(error: Error, info: ErrorInfo) {
    captureException(error, { info });
    this.setState({ globalUiError: true });
  }

  render() {
    const { globalUiError } = this.state;
    if (globalUiError) {
      return <UiError />;
    }
    return <App />;
  }
}
